import { useCallback, useEffect, useState } from 'react'

/**
 * Тема. Начальное значение выставляет короткий скрипт в index.html до отрисовки —
 * иначе тёмный интерфейс моргает белым. Здесь только переключение и запоминание.
 */

const STORAGE_KEY = 'rooms-theme'

export type Theme = 'light' | 'dark'

function currentTheme(): Theme {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

export function useTheme(): { theme: Theme; toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(() => currentTheme())

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
    try {
      localStorage.setItem(STORAGE_KEY, theme)
    } catch {
      // Приватный режим — тема просто не запомнится.
    }
  }, [theme])

  const toggle = useCallback(() => {
    setTheme((previous) => (previous === 'dark' ? 'light' : 'dark'))
  }, [])

  return { theme, toggle }
}
